import UploadIcon from "../../../Icon-SVG/UploadIcon";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  RequestSetReportLogo,
  RequestGetReportLogo,
} from "../../../../store/actions/analysisReportActions";
import { MA360_REPORT_LOGO } from "../../../../utils/constants/reportLogos";
import "./styles.scss";

// Shared by both report previews, which fall back to different logos
const SelectLogo = ({ defaultLogo = MA360_REPORT_LOGO }) => {
  const dispatch = useDispatch();
  const [bannerLogo, setBannerLogo] = useState("");
  const reportLogo = useSelector((state) => state.analysisReports.reportLogo);
  var bannerImg = document.getElementById("tableBanner");

  const setViewLogo = (logoSrc) => {
    setBannerLogo(logoSrc);
  };

  useEffect(() => {
    dispatch(RequestGetReportLogo());
  }, []);

  useEffect(() => {
    setBannerLogo(reportLogo ? "data:image/png;base64," + reportLogo : defaultLogo);
  }, [reportLogo, defaultLogo]);

  const imageUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image")) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64StringUS = reader.result.replace("data:", "").replace(/^.+,/, "");
        localStorage.setItem("wallpaperXXX", base64StringUS);
        const myImage = localStorage.getItem("wallpaperXXX");
        bannerImg = document.getElementById("tableBanner");
        setViewLogo("data:image/png;base64," + myImage);
        dispatch(RequestSetReportLogo(file));
      };
      reader.readAsDataURL(file);
    } else {
      alert("Please select an image file.");
    }
  };

  return (
    <div className="selectlogo">
      <div className="selectlogo__container">
        <img alt="Report logo" id="tableBanner" className="selectlogo__img" src={bannerLogo} />

        <label htmlFor="imageFile" className="selectlogo--img-upload primary-button">
          Upload
          <UploadIcon color="var(--header-search-text-color)" width={14} height={14} />
        </label>
        <input
          className="selectlogo--input"
          type="file"
          id="imageFile"
          placeholder="deneme"
          name="imageFile"
          onChange={imageUpload}
        />
      </div>
    </div>
  );
};

export default SelectLogo;
